// extracted by mini-css-extract-plugin
module.exports = {"content":"StarRating_content__26ONa","wrapper":"StarRating_wrapper__31WDU","contentUnrated":"StarRating_contentUnrated__QfE4s"};